import React, { useState, useCallback } from "react";
import { Flex, Text, Button, AcceptIcon } from "@fluentui/react-northstar";
import { useTranslation } from "react-i18next";

import { PageHeader } from "../page-header/pageHeader";

import { useTestCompletedStyles } from "./TestCompleted.styles";
import { TestCompletedProps } from "./TestCompleted.types";

export const TestCompleted: React.FC<TestCompletedProps> = ({
  isAuthFlow,
  sendResults,
}) => {
  const testCompletedStyles = useTestCompletedStyles();
  const [resultsSent, setResultsSent] = useState(false);
  const { t } = useTranslation();

  const testResultShared = t("TEST_RESULT_SHARED");
  const shareTestResult = t("SHARE_TEST_RESULT");

  const sendTestResults = useCallback(() => {
    setResultsSent(true);
    sendResults();
  }, [sendResults, setResultsSent]);

  if (isAuthFlow) {
    return (
      <Flex
        vAlign="center"
        hAlign="center"
        gap="gap.large"
        column
        styles={testCompletedStyles.container}
      >
        <PageHeader
          headerStyles={testCompletedStyles.header}
          headerContent={t("TEST_COMPLETE")}
          descriptionStyles={testCompletedStyles.description}
          descriptionContent={t("TEST_COMPLETED_DESCRIPTION")}
        />
        <Flex column vAlign="center" hAlign="center" gap="gap.medium">
          <Button
            className="focus-button"
            aria-live="polite"
            secondary
            data-testid="shareResultsButton"
            content={
              <Text
                styles={
                  resultsSent
                    ? testCompletedStyles.buttonContent
                    : testCompletedStyles.textColor
                }
                size="medium"
                weight="semibold"
                align="center"
                content={resultsSent ? testResultShared : shareTestResult}
              />
            }
            icon={
              resultsSent ? (
                <AcceptIcon styles={testCompletedStyles.buttonContent} />
              ) : undefined
            }
            onClick={resultsSent ? undefined : sendTestResults}
            disabled={resultsSent}
            inverted
            styles={
              resultsSent
                ? testCompletedStyles.postshareResultsButton
                : testCompletedStyles.preshareResultsButton
            }
          />
        </Flex>
      </Flex>
    );
  } else {
    return (
      <Flex
        vAlign="center"
        hAlign="center"
        gap="gap.large"
        column
        styles={testCompletedStyles.container}
      >
        <PageHeader
          headerStyles={testCompletedStyles.header}
          headerContent={t("TEST_COMPLETE")}
          descriptionStyles={testCompletedStyles.description}
          descriptionContent={t("TEST_COMPLETE_ANONYMOUS")}
        />
      </Flex>
    );
  }
};
